/*
 *
 *
 *
 *   Copyright (c) 2022. TinyMedic Pvt Ltd  - All Rights Reserved.
 *   This file is part of the API module  of the project: TinyMedic-Platform.
 *
 *
 *   Proprietary and confidential.
 *
 *   Unauthorized copying of this file, via any medium is strictly prohibited.
 *    Any resources of   TinyMedic-Platform can not be copied and/or distributed without the express permission of TinyMedic Pvt Ltd.
 *
 *
 *
 */

import React, { useEffect } from 'react';
import { Link, useNavigate, useParams } from 'react-router-dom';
import { Button, Col, Row, UncontrolledTooltip } from 'reactstrap';
import { Translate, ValidatedField, ValidatedForm, isNumber, translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { mapIdList } from 'app/shared/util/entity-utils';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntities as getAccountingBankAccounts } from 'app/entities/accounting-bank-account/accounting-bank-account.reducer';
import { getEntities as getClinicalDictionaries } from 'app/entities/clinical-dictionary/clinical-dictionary.reducer';
import { getEntities as getAccountingCurrencies } from 'app/entities/accounting-currency/accounting-currency.reducer';
import { getEntities as getAccountingTaxes } from 'app/entities/accounting-tax/accounting-tax.reducer';
import { getEntities as getAccountingCollectionLedgers } from 'app/entities/accounting-collection-ledger/accounting-collection-ledger.reducer';
import { getEntities as getAccountingTransactions } from 'app/entities/accounting-transaction/accounting-transaction.reducer';
import { getEntities as getAccountingReconciliations } from 'app/entities/accounting-reconciliation/accounting-reconciliation.reducer';
import { AddedByType } from 'app/shared/model/enumerations/added-by-type.model';
import { createEntity, getEntity, reset, updateEntity } from './accounting-transaction.reducer';

export const AccountingTransactionUpdate = () => {
  const dispatch = useAppDispatch();

  const navigate = useNavigate();

  const { id } = useParams<'id'>();
  const isNew = id === undefined;

  const accountingBankAccounts = useAppSelector(state => state.accountingBankAccount.entities);
  const clinicalDictionaries = useAppSelector(state => state.clinicalDictionary.entities);
  const accountingCurrencies = useAppSelector(state => state.accountingCurrency.entities);
  const accountingTaxes = useAppSelector(state => state.accountingTax.entities);
  const accountingCollectionLedgers = useAppSelector(state => state.accountingCollectionLedger.entities);
  const accountingTransactions = useAppSelector(state => state.accountingTransaction.entities);
  const accountingReconciliations = useAppSelector(state => state.accountingReconciliation.entities);
  const accountingTransactionEntity = useAppSelector(state => state.accountingTransaction.entity);
  const loading = useAppSelector(state => state.accountingTransaction.loading);
  const updating = useAppSelector(state => state.accountingTransaction.updating);
  const updateSuccess = useAppSelector(state => state.accountingTransaction.updateSuccess);
  const addedByTypeValues = Object.keys(AddedByType);

  const handleClose = () => {
    navigate(`/accounting-transaction${location.search}`);
  };

  useEffect(() => {
    if (isNew) {
      dispatch(reset());
    } else {
      dispatch(getEntity(id));
    }

    dispatch(getAccountingBankAccounts({}));
    dispatch(getClinicalDictionaries({}));
    dispatch(getAccountingCurrencies({}));
    dispatch(getAccountingTaxes({}));
    dispatch(getAccountingCollectionLedgers({}));
    dispatch(getAccountingTransactions({}));
    dispatch(getAccountingReconciliations({}));
  }, []);

  useEffect(() => {
    if (updateSuccess) {
      handleClose();
    }
  }, [updateSuccess]);

  const saveEntity = values => {
    if (values.paidAt !== undefined && typeof values.paidAt !== 'number') {
      values.paidAt = Number(values.paidAt);
    }
    if (values.amount !== undefined && typeof values.amount !== 'number') {
      values.amount = Number(values.amount);
    }
    if (values.currencyRate !== undefined && typeof values.currencyRate !== 'number') {
      values.currencyRate = Number(values.currencyRate);
    }
    if (values.cursor !== undefined && typeof values.cursor !== 'number') {
      values.cursor = Number(values.cursor);
    }
    if (values.lastUpdated !== undefined && typeof values.lastUpdated !== 'number') {
      values.lastUpdated = Number(values.lastUpdated);
    }
    if (values.microSec !== undefined && typeof values.microSec !== 'number') {
      values.microSec = Number(values.microSec);
    }
    if (values.timestampEntry !== undefined && typeof values.timestampEntry !== 'number') {
      values.timestampEntry = Number(values.timestampEntry);
    }
    if (values.resultingBalance !== undefined && typeof values.resultingBalance !== 'number') {
      values.resultingBalance = Number(values.resultingBalance);
    }

    const entity = {
      ...accountingTransactionEntity,
      ...values,
      account: accountingBankAccounts.find(it => it.id.toString() === values.account?.toString()),
      category: clinicalDictionaries.find(it => it.id.toString() === values.category?.toString()),
      paymentMethod: clinicalDictionaries.find(it => it.id.toString() === values.paymentMethod?.toString()),
      currency: accountingCurrencies.find(it => it.id.toString() === values.currency?.toString()),
      taxes: mapIdList(values.taxes),
      transactions: mapIdList(values.transactions),
      parent: accountingTransactions.find(it => it.id.toString() === values.parent?.toString()),
      reconciliations: mapIdList(values.reconciliations),
    };

    if (isNew) {
      dispatch(createEntity(entity));
    } else {
      dispatch(updateEntity(entity));
    }
  };

  const defaultValues = () =>
    isNew
      ? {}
      : {
          createdByType: 'ACCOUNTANT',
          ...accountingTransactionEntity,
          account: accountingTransactionEntity?.account?.id,
          category: accountingTransactionEntity?.category?.id,
          paymentMethod: accountingTransactionEntity?.paymentMethod?.id,
          currency: accountingTransactionEntity?.currency?.id,
          taxes: accountingTransactionEntity?.taxes?.map(e => e.id.toString()),
          transactions: accountingTransactionEntity?.transactions?.map(e => e.id.toString()),
          parent: accountingTransactionEntity?.parent?.id,
          reconciliations: accountingTransactionEntity?.reconciliations?.map(e => e.id.toString()),
        };

  return (
    <div>
      <Row className="justify-content-center">
        <Col md="8">
          <h2 id="tinyMedicRestApp.accountingTransaction.home.createOrEditLabel" data-cy="AccountingTransactionCreateUpdateHeading">
            <Translate contentKey="tinyMedicRestApp.accountingTransaction.home.createOrEditLabel">
              Create or edit a AccountingTransaction
            </Translate>
          </h2>
        </Col>
      </Row>
      <Row className="justify-content-center">
        <Col md="8">
          {loading ? (
            <p>Loading...</p>
          ) : (
            <ValidatedForm defaultValues={defaultValues()} onSubmit={saveEntity}>
              {!isNew ? (
                <ValidatedField
                  name="id"
                  required
                  readOnly
                  id="accounting-transaction-id"
                  label={translate('tinyMedicRestApp.accountingTransaction.id')}
                  validate={{ required: true }}
                />
              ) : null}
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.type')}
                id="accounting-transaction-type"
                name="type"
                data-cy="type"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                }}
              />
              <UncontrolledTooltip target="typeLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.type" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.transactionNumber')}
                id="accounting-transaction-transactionNumber"
                name="transactionNumber"
                data-cy="transactionNumber"
                type="text"
              />
              <UncontrolledTooltip target="transactionNumberLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.transactionNumber" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.paidAt')}
                id="accounting-transaction-paidAt"
                name="paidAt"
                data-cy="paidAt"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="paidAtLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.paidAt" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.amount')}
                id="accounting-transaction-amount"
                name="amount"
                data-cy="amount"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="amountLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.amount" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.currencyRate')}
                id="accounting-transaction-currencyRate"
                name="currencyRate"
                data-cy="currencyRate"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="currencyRateLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.currencyRate" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.description')}
                id="accounting-transaction-description"
                name="description"
                data-cy="description"
                type="text"
              />
              <UncontrolledTooltip target="descriptionLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.description" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.reconciled')}
                id="accounting-transaction-reconciled"
                name="reconciled"
                data-cy="reconciled"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="reconciledLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.reconciled" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.active')}
                id="accounting-transaction-active"
                name="active"
                data-cy="active"
                check
                type="checkbox"
              />
              <UncontrolledTooltip target="activeLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.active" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.cursor')}
                id="accounting-transaction-cursor"
                name="cursor"
                data-cy="cursor"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="cursorLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.cursor" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.lastUpdated')}
                id="accounting-transaction-lastUpdated"
                name="lastUpdated"
                data-cy="lastUpdated"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="lastUpdatedLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.lastUpdated" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.microSec')}
                id="accounting-transaction-microSec"
                name="microSec"
                data-cy="microSec"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="microSecLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.microSec" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.timestampEntry')}
                id="accounting-transaction-timestampEntry"
                name="timestampEntry"
                data-cy="timestampEntry"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="timestampEntryLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.timestampEntry" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.resultingBalance')}
                id="accounting-transaction-resultingBalance"
                name="resultingBalance"
                data-cy="resultingBalance"
                type="text"
                validate={{
                  required: { value: true, message: translate('entity.validation.required') },
                  validate: v => isNumber(v) || translate('entity.validation.number'),
                }}
              />
              <UncontrolledTooltip target="resultingBalanceLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.resultingBalance" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.createdById')}
                id="accounting-transaction-createdById"
                name="createdById"
                data-cy="createdById"
                type="text"
              />
              <UncontrolledTooltip target="createdByIdLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.createdById" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.createdByType')}
                id="accounting-transaction-createdByType"
                name="createdByType"
                data-cy="createdByType"
                type="select"
              >
                {addedByTypeValues.map(addedByType => (
                  <option value={addedByType} key={addedByType}>
                    {translate(`tinyMedicRestApp.AddedByType.${addedByType}`)}
                  </option>
                ))}
              </ValidatedField>
              <UncontrolledTooltip target="createdByTypeLabel">
                <Translate contentKey="tinyMedicRestApp.accountingTransaction.help.createdByType" />
              </UncontrolledTooltip>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.pharmacySupplierId')}
                id="accounting-transaction-pharmacySupplierId"
                name="pharmacySupplierId"
                data-cy="pharmacySupplierId"
                type="text"
              />
              <ValidatedField
                id="accounting-transaction-account"
                name="account"
                data-cy="account"
                label={translate('tinyMedicRestApp.accountingTransaction.account')}
                type="select"
              >
                <option value="" key="0" />
                {accountingBankAccounts
                  ? accountingBankAccounts.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="accounting-transaction-category"
                name="category"
                data-cy="category"
                label={translate('tinyMedicRestApp.accountingTransaction.category')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="accounting-transaction-paymentMethod"
                name="paymentMethod"
                data-cy="paymentMethod"
                label={translate('tinyMedicRestApp.accountingTransaction.paymentMethod')}
                type="select"
              >
                <option value="" key="0" />
                {clinicalDictionaries
                  ? clinicalDictionaries.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="accounting-transaction-currency"
                name="currency"
                data-cy="currency"
                label={translate('tinyMedicRestApp.accountingTransaction.currency')}
                type="select"
              >
                <option value="" key="0" />
                {accountingCurrencies
                  ? accountingCurrencies.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.tax')}
                id="accounting-transaction-tax"
                data-cy="tax"
                type="select"
                multiple
                name="taxes"
              >
                <option value="" key="0" />
                {accountingTaxes
                  ? accountingTaxes.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.transaction')}
                id="accounting-transaction-transaction"
                data-cy="transaction"
                type="select"
                multiple
                name="transactions"
              >
                <option value="" key="0" />
                {accountingCollectionLedgers
                  ? accountingCollectionLedgers.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                id="accounting-transaction-parent"
                name="parent"
                data-cy="parent"
                label={translate('tinyMedicRestApp.accountingTransaction.parent')}
                type="select"
              >
                <option value="" key="0" />
                {accountingTransactions
                  ? accountingTransactions.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <ValidatedField
                label={translate('tinyMedicRestApp.accountingTransaction.reconciliation')}
                id="accounting-transaction-reconciliation"
                data-cy="reconciliation"
                type="select"
                multiple
                name="reconciliations"
              >
                <option value="" key="0" />
                {accountingReconciliations
                  ? accountingReconciliations.map(otherEntity => (
                      <option value={otherEntity.id} key={otherEntity.id}>
                        {otherEntity.id}
                      </option>
                    ))
                  : null}
              </ValidatedField>
              <Button tag={Link} id="cancel-save" data-cy="entityCreateCancelButton" to="/accounting-transaction" replace color="info">
                <FontAwesomeIcon icon="arrow-left" />
                &nbsp;
                <span className="d-none d-md-inline">
                  <Translate contentKey="entity.action.back">Back</Translate>
                </span>
              </Button>
              &nbsp;
              <Button color="primary" id="save-entity" data-cy="entityCreateSaveButton" type="submit" disabled={updating}>
                <FontAwesomeIcon icon="save" />
                &nbsp;
                <Translate contentKey="entity.action.save">Save</Translate>
              </Button>
            </ValidatedForm>
          )}
        </Col>
      </Row>
    </div>
  );
};

export default AccountingTransactionUpdate;
